export const strategies = {
    paid: 'Paid',
    barter: 'Barter'
}

export const genders = {
    A: 'Any',
    M: 'Male',
    F: 'Female',
    U: 'Any'
}